module.exports = __webpack_public_path__ + "static/media/selected.0d8da857.svg";